module.exports = __webpack_public_path__ + "img/gear.41a455e1.svg";